import type { CaptionStyleSpec } from "@/lib/caption-styles/content";

const ROWS: { key: keyof CaptionStyleSpec; label: string }[] = [
  { key: "font", label: "Font" },
  { key: "case", label: "Case" },
  { key: "highlight", label: "Highlight" },
  { key: "animation", label: "Animation" },
  { key: "background", label: "Background" },
  { key: "bestFor", label: "Best for" },
];

const CaptionStyleSpecs = ({ spec }: { spec: CaptionStyleSpec }) => (
  <dl className="grid grid-cols-1 overflow-hidden rounded-2xl border border-[#EFF2FF] bg-white shadow-sm sm:grid-cols-2">
    {ROWS.map((row, index) => (
      <div
        key={row.key}
        className={
          index < ROWS.length - 1
            ? "flex flex-col gap-1 border-b border-[#EFF2FF] px-5 py-4 sm:[&:nth-last-child(2)]:border-b-0"
            : "flex flex-col gap-1 px-5 py-4"
        }
      >
        <dt className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
          {row.label}
        </dt>
        <dd className="text-[14.5px] leading-[1.5] text-[#101828]">{spec[row.key]}</dd>
      </div>
    ))}
  </dl>
);

export default CaptionStyleSpecs;
